// @flow

import AttachmentStorageApi from "../../api/AttachmentApi/AttachmentStorageApi";
import DonationApi from "../../api/DonationApi/DonationApi";
import { CreateInKindDonationRequest, UpdateInKindDonationRequest } from "../../models/InKindDonation/InKindDonation";
import { AttachmentTypeEnum } from "../../models/Attachment/Attachment";

class DonationService {

    donationApi: DonationApi;
    attachmentStorageApi: AttachmentStorageApi;

    constructor(donationApi: DonationApi, attachmentStorageApi: AttachmentStorageApi) {
        this.donationApi = donationApi;
        this.attachmentStorageApi = attachmentStorageApi;
    }

    async createDonation(createDonationRequest: CreateInKindDonationRequest): Promise<any> {
        const donation = await this.donationApi.createDonation(createDonationRequest);
        console.log("DonationService.createDonation - response:", donation);
        console.log("DonationService.createDonation - has putUrl?", !!donation?.putUrl);
        console.log("DonationService.createDonation - has attachment.putUrl?", !!donation?.attachment?.putUrl);
        // Check if attachment response includes putUrl (for S3 upload)
        if(donation && (donation.attachment?.putUrl || donation.putUrl)){
            try {
                const putUrl = donation.attachment?.putUrl || donation.putUrl;
                console.log("DonationService.createDonation - calling putAttachmentPayload with putUrl:", putUrl);
                await this.attachmentStorageApi.putAttachmentPayload(putUrl, createDonationRequest, AttachmentTypeEnum.donation);
                console.log("DonationService.createDonation - S3 upload successful");
            } catch (error) {
                console.error("DonationService.createDonation - S3 upload error:", error);
                throw new Error(`Donation created but attachment upload failed: ${error.message || 'Unknown error'}`);
            }
        } else {
            console.log("DonationService.createDonation - no putUrl found, skipping S3 upload");
        }
        return donation;
    }

    async updateDonation(updateDonationRequest: UpdateInKindDonationRequest): Promise<any> {
        const donation = await this.donationApi.updateDonation(updateDonationRequest);
        console.log("DonationService.updateDonation - response:", donation);
        console.log("DonationService.updateDonation - has putUrl?", !!donation?.putUrl);
        console.log("DonationService.updateDonation - has attachment.putUrl?", !!donation?.attachment?.putUrl);
        // Check if attachment response includes putUrl (for S3 upload)
        if(donation && (donation.attachment?.putUrl || donation.putUrl)){
            try {
                const putUrl = donation.attachment?.putUrl || donation.putUrl;
                console.log("DonationService.updateDonation - calling putAttachmentPayload with putUrl:", putUrl);
                await this.attachmentStorageApi.putAttachmentPayload(putUrl, updateDonationRequest, AttachmentTypeEnum.donation);
                console.log("DonationService.updateDonation - S3 upload successful");
            } catch (error) {
                console.error("DonationService.updateDonation - S3 upload error:", error);
                throw new Error(`Donation updated but attachment upload failed: ${error.message || 'Unknown error'}`);
            }
        } else {
            console.log("DonationService.updateDonation - no putUrl found, skipping S3 upload");
        }
        return donation;
    }

    async deleteDonation(projectId: string, donationId: string): Promise<void> {
        await this.donationApi.deleteDonation(projectId, donationId);
    }
}

export default DonationService;
